import {
  ACCOUNTS_RECEIVABLE_SALES_JOURNAL,
  ACCOUNT_GROUP,
  ACCOUNT_NUMBER,
  ACL,
  ACTION,
  ADD_ON,
  AEREPORTS,
  AGENCY_PERFERMANCE_OVERVIEW,
  AGE_RANGES,
  APPLICATION_SETTINGS,
  ARRIVAL,
  AR_ACCOUNT,
  BILLING,
  BILLING_GROUP,
  BILLING_MANAGER,
  BLOCS,
  BOARDS,
  BOARD_SERVICE_SETTINGS,
  BOOK,
  CANCEL,
  CARDS,
  CASHIER,
  CASH_CATEGORY,
  CASH_OPERATION_REGISTER,
  CASH_REGISTER,
  CHARGE_CODE,
  CHARGE_GROUP,
  CHECK_IN,
  CHECK_OUT,
  COMPANY_TA_CARDS,
  COMPANY_TA_CARDS_GROUP,
  COMPLETE,
  COMPLIMENTARY_CATEGORY,
  CONCIERGE,
  COUNTER,
  COUNTER_SETTINGS,
  CREATE_RESERVATION,
  CURRENCY,
  DAILY_FORECAST,
  DAILY_REPORT,
  DASHBOARD,
  DEPARTURE,
  DESTROY,
  DISCOUNT_TYPE,
  DO_CHECKOUT,
  DO_EARLY_CHECKOUT,
  DUPLICATE,
  EDIT_DEPARTURE,
  EDIT_MARKET_CODE,
  END_OF_DAY_CHECK,
  EXCHANGE,
  FINANCIAL,
  FINANCIAL_ACCOUNT,
  FLASH_MANAGER,
  FORECAST,
  FORECAST_BY_ROOM_TYPE,
  FOUR_WEEK_FORECAST,
  FREQUENCY,
  FRONT_DESK,
  FRONT_DESK_MANAGER,
  GROUPS,
  GROUP_RESERVATION,
  GUEST,
  GUEST_CARD_FILEDS,
  HOTEL,
  HOUSE_KEEPER,
  HOUSE_KEEPING,
  HOUSE_KEEPING_REPORT,
  HOUSE_KEEPING_WORK_MANAGEMENT,
  INVOICE_CHARGE_GROUP,
  IN_HOUSE,
  ITEMS,
  LIKES,
  LOGS,
  MAINTENANCE,
  MAINTENANCE_TYPE,
  MOVE_CHARGE,
  MOVE_PAYMENT,
  NATIONALITY_FORECAST,
  NIGHT_AUDIT,
  NOTE,
  ORIGINE_OF_BOOKING,
  PACKAGES,
  PAY,
  PAYMENT,
  PAYMENT_METHODS,
  POST_NEGATIVE_CHARGE,
  POST_NEGATIVE_PAYMENT,
  PROMOS,
  PROMOTION_AND_CHARGE_RULES,
  PROPERTY_AND_STAFF,
  RANGE_TEMPLATE,
  RATES,
  RATES_PROMO,
  RATE_EXCHANGE,
  RATE_MANAGER,
  RATE_TYPE,
  READ,
  REPORT,
  RESERVATION,
  RESERVATION_LIST,
  RESERVATION_STATES,
  REVENU_MANAGEMENT,
  ROOMS,
  ROOM_CATEGORIES,
  ROOM_FLOORS,
  ROOM_LISTS,
  ROOM_PLAN,
  ROOM_STATE,
  ROOM_TYPES,
  RULES_AND_RESTRICTIONS,
  SEARCH_RESERVATION,
  SEASON,
  SECTIONS,
  SEGMENT_MARKET_CODE,
  SETTINGS,
  SHOW_DETAILS,
  SOURCES,
  STATE,
  SUMMARY,
  TRANSACTIONS_LIST,
  TRANSFER_EXCURSION,
  TRIAL_BALANCE,
  UNDO_CHECK_IN,
  UNDO_CHECK_OUT,
  UPDATE,
  VIP_CATEGORIES,
  WORK_TASK,
  WORK_TYPE,
  WRITE,
} from './app_permissions';

export const APP_STRUCTURE = {
  [HOTEL]: {
    code: HOTEL,
    name: 'hotel',
    children: {
      [DASHBOARD]: {
        code: DASHBOARD,
        name: 'dashboard',
        dependenciesApiPermissions: [],
      },
      [BILLING_MANAGER]: {
        code: BILLING_MANAGER,
        name: 'Billing manager',
        children: {
          [MOVE_PAYMENT]: {
            code: MOVE_PAYMENT,
            name: 'Move payment',
            dependenciesApiPermissions: [],
          },
          [POST_NEGATIVE_CHARGE]: {
            code: POST_NEGATIVE_CHARGE,
            name: 'Post negative charge',
            dependenciesApiPermissions: [],
          },
          [POST_NEGATIVE_PAYMENT]: {
            code: POST_NEGATIVE_PAYMENT,
            name: 'Post negative payment',
            dependenciesApiPermissions: [],
          },
          [MOVE_CHARGE]: {
            code: MOVE_CHARGE,
            name: 'Move charge',
            dependenciesApiPermissions: [],
          },
        },
      },
      [FRONT_DESK_MANAGER]: {
        code: FRONT_DESK_MANAGER,
        name: 'Front desk manager',
        children: {
          [CHECK_IN]: {
            code: CHECK_IN,
            name: 'Checkin',
            dependenciesApiPermissions: [],
          },
          [CHECK_OUT]: {
            code: CHECK_OUT,
            name: 'Checkout',
            dependenciesApiPermissions: [],
          },
          [CANCEL]: {
            code: CANCEL,
            name: 'Cancel',
            dependenciesApiPermissions: [],
          },
          [UNDO_CHECK_IN]: {
            code: UNDO_CHECK_IN,
            name: 'Undo check in',
            dependenciesApiPermissions: [],
          },
          [UNDO_CHECK_OUT]: {
            code: UNDO_CHECK_OUT,
            name: 'Undo check out',
            dependenciesApiPermissions: [],
          },
          [DUPLICATE]: {
            code: DUPLICATE,
            name: 'Duplicate',
            dependenciesApiPermissions: [],
          },
        },
      },
      [RESERVATION]: {
        code: RESERVATION,
        name: 'reservation',
        children: {
          [SEARCH_RESERVATION]: {
            code: SEARCH_RESERVATION,
            name: 'search_reservation',
            dependenciesApiPermissions: [],
            children: {
              [ACTION]: {
                code: ACTION,
                name: 'action',
                children: {
                  [READ]: {
                    code: READ,
                    name: 'read',
                    dependenciesApiPermissions: [],
                  },
                  [WRITE]: {
                    code: WRITE,
                    name: 'write',
                    dependenciesApiPermissions: [],
                  },
                  [UPDATE]: {
                    code: UPDATE,
                    name: 'update',
                    dependenciesApiPermissions: [],
                  },
                  [DESTROY]: {
                    code: DESTROY,
                    name: 'destroy',
                    dependenciesApiPermissions: [],
                  },
                },
              },
              [NOTE]: {
                code: NOTE,
                name: 'note',
                children: {
                  [READ]: {
                    code: READ,
                    name: 'read',
                    dependenciesApiPermissions: [],
                  },
                  [WRITE]: {
                    code: WRITE,
                    name: 'write',
                    dependenciesApiPermissions: [],
                  },
                  [COMPLETE]: {
                    code: COMPLETE,
                    name: 'complete',
                    dependenciesApiPermissions: [],
                  },
                  [UPDATE]: {
                    code: UPDATE,
                    name: 'update',
                    dependenciesApiPermissions: [],
                  },
                  [DESTROY]: {
                    code: DESTROY,
                    name: 'destroy',
                    dependenciesApiPermissions: [],
                  },
                },
              },
            },
          },
          [CREATE_RESERVATION]: {
            code: CREATE_RESERVATION,
            name: 'Create reservation',
            dependenciesApiPermissions: [],
            children: {
              [SUMMARY]: {
                code: SUMMARY,
                name: 'summary',
                dependenciesApiPermissions: [],
              },
              [BOOK]: {
                code: BOOK,
                name: 'book',
                dependenciesApiPermissions: [],
              },
              [PAY]: {
                code: PAY,
                name: 'pay',
                dependenciesApiPermissions: [],
              },
            },
          },
          [FORECAST]: {
            code: FORECAST,
            name: 'forecast',
            dependenciesApiPermissions: [],
          },
          [GUEST]: {
            code: GUEST,
            name: 'guest',
            dependenciesApiPermissions: [],
          },
          [FINANCIAL_ACCOUNT]: {
            code: FINANCIAL_ACCOUNT,
            name: 'financial_account',
            dependenciesApiPermissions: [],
            children: {
              [SHOW_DETAILS]: {
                code: SHOW_DETAILS,
                name: 'show_details',
                dependenciesApiPermissions: [],
                children: {
                  [EDIT_DEPARTURE]: {
                    code: EDIT_DEPARTURE,
                    name: 'edit_departure',
                    dependenciesApiPermissions: [],
                  },
                  [EDIT_MARKET_CODE]: {
                    code: EDIT_MARKET_CODE,
                    name: 'edit_market_code',
                    dependenciesApiPermissions: [],
                  },
                  [DO_CHECKOUT]: {
                    code: DO_CHECKOUT,
                    name: 'do_checkout',
                    dependenciesApiPermissions: [],
                  },
                  [DO_EARLY_CHECKOUT]: {
                    code: DO_EARLY_CHECKOUT,
                    name: 'do_early_checkout',
                    dependenciesApiPermissions: [],
                  },
                },
              },
            },
          },
          [GROUP_RESERVATION]: {
            code: GROUP_RESERVATION,
            name: 'group_reservation',
          },
        },
      },
      [GROUPS]: {
        code: GROUPS,
        name: 'groups',
      },
      [FRONT_DESK]: {
        code: FRONT_DESK,
        name: 'front_desk',
        children: {
          [ARRIVAL]: {
            code: ARRIVAL,
            name: 'arrival',
          },
          [DEPARTURE]: {
            code: DEPARTURE,
            name: 'departure',
          },
          [IN_HOUSE]: {
            code: IN_HOUSE,
            name: 'in_house',
          },
          [ROOM_PLAN]: {
            code: ROOM_PLAN,
            name: 'room_plan',
          },
        },
      },
      [CONCIERGE]: {
        code: CONCIERGE,
        name: 'concierge',
      },
      [CASHIER]: {
        code: CASHIER,
        name: 'cashier',
        children: {
          [CASH_REGISTER]: {
            code: CASH_REGISTER,
            name: 'cash_register',
          },
          [EXCHANGE]: {
            code: EXCHANGE,
            name: 'exchange',
          },
          [RATE_EXCHANGE]: {
            code: RATE_EXCHANGE,
            name: 'rate_exchange',
          },
          [BILLING]: {
            code: BILLING,
            name: 'billing',
          },
        },
      },
      [REVENU_MANAGEMENT]: {
        code: REVENU_MANAGEMENT,
        name: 'revenu_management',
        children: {
          [COMPANY_TA_CARDS]: {
            code: COMPANY_TA_CARDS,
            name: 'company_ta_cards',
          },
          [RATES]: {
            code: RATES,
            name: 'rates',
          },
          [RATE_MANAGER]: {
            code: RATE_MANAGER,
            name: 'rate_manager',
          },
          [PROMOS]: {
            code: PROMOS,
            name: 'promos',
          },
          [END_OF_DAY_CHECK]: {
            code: END_OF_DAY_CHECK,
            name: 'end_of_day_check',
          },
          [FLASH_MANAGER]: {
            code: FLASH_MANAGER,
            name: 'flash_manager',
          },
        },
      },
      [HOUSE_KEEPING]: {
        code: HOUSE_KEEPING,
        name: 'house_keeping',
        children: {
          [HOUSE_KEEPING_REPORT]: {
            code: HOUSE_KEEPING_REPORT,
            name: 'house_keeping_roomStatus',
          },
          [HOUSE_KEEPING_WORK_MANAGEMENT]: {
            code: HOUSE_KEEPING_WORK_MANAGEMENT,
            name: 'house_keeping_workManagement',
          },
        },
      },
      [MAINTENANCE]: {
        code: MAINTENANCE,
        name: 'maintenance',
        children: {
          [HOUSE_KEEPING_REPORT]: {
            code: HOUSE_KEEPING_REPORT,
            name: 'house_keeping_roomStatus',
          },
          [HOUSE_KEEPING_WORK_MANAGEMENT]: {
            code: HOUSE_KEEPING_WORK_MANAGEMENT,
            name: 'house_keeping_workManagement',
          },
        },
      },
      [FINANCIAL]: {
        code: FINANCIAL,
        name: 'financial',
        children: {
          [AR_ACCOUNT]: {
            code: AR_ACCOUNT,
            name: 'ar_account',
          },
        },
      },
      [REPORT]: {
        code: REPORT,
        name: 'report',
        children: {
          [RESERVATION]: {
            code: RESERVATION,
            name: 'reservation',
            children: {
              [DAILY_FORECAST]: {
                code: DAILY_FORECAST,
                name: 'daily_forecast',
              },
              [FORECAST_BY_ROOM_TYPE]: {
                code: FORECAST_BY_ROOM_TYPE,
                name: 'forecast_by_room_type',
              },
              [FOUR_WEEK_FORECAST]: {
                code: FOUR_WEEK_FORECAST,
                name: 'four_week_forecast',
              },
              [RESERVATION_LIST]: {
                code: RESERVATION_LIST,
                name: 'reservation_list',
              },
              [NATIONALITY_FORECAST]: {
                code: NATIONALITY_FORECAST,
                name: 'Nationality Forecast',
              },
            },
          },
          [FRONT_DESK]: {
            code: FRONT_DESK,
            name: 'front_desk',
            children: {
              [ARRIVAL]: {
                code: ARRIVAL,
                name: 'arrival',
              },
              [DEPARTURE]: {
                code: DEPARTURE,
                name: 'departure',
              },
              [IN_HOUSE]: {
                code: IN_HOUSE,
                name: 'in_house',
              },
              [ROOM_STATE]: {
                code: ROOM_STATE,
                name: 'room_state',
              },
              [DAILY_REPORT]: {
                code: DAILY_REPORT,
                name: 'daily_report',
              },
              [LOGS]: {
                code: LOGS,
                name: 'logs',
              },
            },
          },
          [CASHIER]: {
            code: CASHIER,
            name: 'cashier',
            children: {
              [CASH_REGISTER]: {
                code: CASH_REGISTER,
                name: 'cash_register',
              },
              [TRANSACTIONS_LIST]: {
                code: TRANSACTIONS_LIST,
                name: 'transactions_list',
              },
            },
          },
          [HOUSE_KEEPING]: {
            code: HOUSE_KEEPING,
            name: 'HOUSE_KEEPING',
          },
          [FINANCIAL]: {
            code: FINANCIAL,
            name: 'financial',
            children: {
              [ACCOUNTS_RECEIVABLE_SALES_JOURNAL]: {
                code: ACCOUNTS_RECEIVABLE_SALES_JOURNAL,
                name: 'accounts receivable sales journal',
              },
              [FLASH_MANAGER]: {
                code: FLASH_MANAGER,
                name: 'Flash manager',
              },
              [TRIAL_BALANCE]: {
                code: TRIAL_BALANCE,
                name: 'Trial balance',
              },
              [AGENCY_PERFERMANCE_OVERVIEW]: {
                code: AGENCY_PERFERMANCE_OVERVIEW,
                name: 'Agency perfermance overview',
              },
            },
          },
          [NIGHT_AUDIT]: {
            code: NIGHT_AUDIT,
            name: 'night_audit',
          },
        },
      },
      [SETTINGS]: {
        code: SETTINGS,
        name: 'settings',
        children: {
          [HOTEL]: {
            code: HOTEL,
            name: 'hotel',
          },
          [PROPERTY_AND_STAFF]: {
            code: PROPERTY_AND_STAFF,
            name: 'proporty_and_staff',
          },
          [RESERVATION]: {
            code: RESERVATION,
            name: 'reservation',
            children: {
              [SEGMENT_MARKET_CODE]: {
                code: SEGMENT_MARKET_CODE,
                name: 'Segment_market_code',
              },
              [RESERVATION_STATES]: {
                code: RESERVATION_STATES,
                name: 'reservation_states',
              },
              [SOURCES]: {
                code: SOURCES,
                name: 'sources',
              },
              [ORIGINE_OF_BOOKING]: {
                code: ORIGINE_OF_BOOKING,
                name: 'origine_of_booking',
              },
              [AEREPORTS]: {
                code: AEREPORTS,
                name: 'aereports',
              },
              [VIP_CATEGORIES]: {
                code: VIP_CATEGORIES,
                name: 'vip_categories',
              },
              [LIKES]: {
                code: LIKES,
                name: 'likes',
              },
              [AGE_RANGES]: {
                code: AGE_RANGES,
                name: 'age_ranges',
              },
            },
          },
          [ROOMS]: {
            code: ROOMS,
            name: 'rooms',
            children: {
              [ROOM_TYPES]: {
                code: ROOM_TYPES,
                name: 'room_types',
              },
              [ROOM_CATEGORIES]: {
                code: ROOM_CATEGORIES,
                name: 'room_categories',
              },
              [ROOM_LISTS]: {
                code: ROOM_LISTS,
                name: 'room_lists',
              },
              [ROOM_FLOORS]: {
                code: ROOM_FLOORS,
                name: 'room_floors',
              },
              [BLOCS]: {
                code: BLOCS,
                name: 'blocs',
              },
            },
          },
          [FINANCIAL]: {
            code: FINANCIAL,
            name: 'financial',
            children: {
              [PAYMENT_METHODS]: {
                code: PAYMENT_METHODS,
                name: 'payment_methods',
              },
              [CURRENCY]: {
                code: CURRENCY,
                name: 'currency',
              },
              [PAYMENT]: {
                code: PAYMENT,
                name: 'payment',
              },
              [CASH_OPERATION_REGISTER]: {
                code: CASH_OPERATION_REGISTER,
                name: 'cash_operation_register',
              },
              [CASH_REGISTER]: {
                code: CASH_REGISTER,
                name: 'cash_register',
              },
              [CASH_CATEGORY]: {
                code: CASH_CATEGORY,
                name: 'cash_category',
              },
              [CASHIER]: {
                code: CASHIER,
                name: 'cashier',
              },
              [ACCOUNT_GROUP]: {
                code: ACCOUNT_GROUP,
                name: 'account_group',
              },
              [ACCOUNT_NUMBER]: {
                code: ACCOUNT_NUMBER,
                name: 'account_number',
              },
              [COUNTER]: {
                code: COUNTER,
                name: 'counter',
              },
              [COUNTER_SETTINGS]: {
                code: COUNTER_SETTINGS,
                name: 'counter_settings',
              },
            },
          },
          [REVENU_MANAGEMENT]: {
            code: REVENU_MANAGEMENT,
            name: 'revenu_management',
            children: {
              [CHARGE_GROUP]: {
                code: CHARGE_GROUP,
                name: 'charge_group',
              },
              [INVOICE_CHARGE_GROUP]: {
                code: INVOICE_CHARGE_GROUP,
                name: 'invoice_charge_group',
              },
              [CHARGE_CODE]: {
                code: CHARGE_CODE,
                name: 'charge_code',
              },
              [ITEMS]: {
                code: ITEMS,
                name: 'items',
              },
              [BILLING_GROUP]: {
                code: BILLING_GROUP,
                name: 'billing_group',
              },
              [PACKAGES]: {
                code: PACKAGES,
                name: 'packages',
              },
              [ADD_ON]: {
                code: ADD_ON,
                name: 'add_on',
              },
              [DISCOUNT_TYPE]: {
                code: DISCOUNT_TYPE,
                name: 'discount_type',
              },
            },
          },
          [HOUSE_KEEPING]: {
            code: HOUSE_KEEPING,
            name: 'house_keeping',
            children: {
              [SECTIONS]: {
                code: SECTIONS,
                name: 'sections',
              },
              [STATE]: {
                code: STATE,
                name: 'state',
              },
              [HOUSE_KEEPER]: {
                code: HOUSE_KEEPER,
                name: 'house_keeper',
              },
              [MAINTENANCE_TYPE]: {
                code: MAINTENANCE_TYPE,
                name: 'maintenance_type',
              },
              [WORK_TYPE]: {
                code: WORK_TYPE,
                name: 'work_type',
              },
              [WORK_TASK]: {
                code: WORK_TASK,
                name: 'work_task',
              },
            },
          },
          [MAINTENANCE]: {
            code: MAINTENANCE,
            name: 'maintenance',
          },
          [TRANSFER_EXCURSION]: {
            code: TRANSFER_EXCURSION,
            name: 'transfer_excursion',
          },
          [RATES_PROMO]: {
            code: RATES_PROMO,
            name: 'rates_promo',
            children: {
              [RANGE_TEMPLATE]: {
                code: RANGE_TEMPLATE,
                name: 'range_template',
              },
              [PROMOTION_AND_CHARGE_RULES]: {
                code: PROMOTION_AND_CHARGE_RULES,
                name: 'promotion_and_charge_rules',
              },
              [RULES_AND_RESTRICTIONS]: {
                code: RULES_AND_RESTRICTIONS,
                name: 'rules_and_restrictions',
              },
              [RATE_TYPE]: {
                code: RATE_TYPE,
                name: 'rate_type',
              },
              [FREQUENCY]: {
                code: FREQUENCY,
                name: 'frequency',
              },
              [SEASON]: {
                code: SEASON,
                name: 'season',
              },
              [BOARDS]: {
                code: BOARDS,
                name: 'boards',
              },
              [BOARD_SERVICE_SETTINGS]: {
                code: BOARD_SERVICE_SETTINGS,
                name: 'board_service_settings',
              },
              [COMPLIMENTARY_CATEGORY]: {
                code: COMPLIMENTARY_CATEGORY,
                name: 'complimentary_category',
              },
            },
          },
          [CARDS]: {
            code: CARDS,
            name: 'cards',
            children: {
              [COMPANY_TA_CARDS_GROUP]: {
                code: COMPANY_TA_CARDS_GROUP,
                name: 'company_ta_cards_group',
              },
              [GUEST_CARD_FILEDS]: {
                code: GUEST_CARD_FILEDS,
                name: 'guest_card_fileds',
              },
            },
          },
          [APPLICATION_SETTINGS]: {
            code: APPLICATION_SETTINGS,
            name: 'application_settings',
          },
          [ACL]: {
            code: ACL,
            name: 'acl',
          },
        },
      },
    },
  },
};
